export const getCalculatedHeight = (trigger: HTMLElement | null, preferredHeight = 400, margin = 8) => {
  const windowHeight = window.innerHeight - 32
  if (!trigger) return { height: preferredHeight, maxHeight: windowHeight }

  const rect = trigger.getBoundingClientRect()
  const spaceAbove = rect.top - margin
  const spaceBelow = window.innerHeight - rect.bottom - margin

  const maxAvailableHeight = Math.max(spaceAbove, spaceBelow)
  const calculatedHeight = Math.min(preferredHeight, maxAvailableHeight > 0 ? maxAvailableHeight : preferredHeight)
  const maxDraggableHeight = spaceAbove > spaceBelow ? windowHeight : spaceBelow

  return { height: calculatedHeight, maxHeight: maxDraggableHeight }
}
